import React, { Fragment } from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import * as premiumApi from "../../api/premiumApi";
import Button from "@mui/material/Button";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import Grid from "@mui/material/Grid";
import { useDropzone } from "react-dropzone";
import Tooltip from "@mui/material/Tooltip";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import swal from "sweetalert";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const styles = {
  root: {
    width: "100%",
  },
  layout: {
    width: "90%",
    paddingTop: 100,
    margin: "auto",
  },
  button: {
    marginTop: 30,
    marginBottom: 20,
  },
  formcontrolselect: {
    minWidth: "70%",
    marginLeft: 20,
  },
  grid: {
    paddingTop: 50,
    marginLeft: 50,
  },
  marginLeft: {
    marginLeft: 30,
  },
  gridPaddingTop: {
    paddingTop: 20,
  },
  headDark: {
    backgroundColor: "#e6e6e6",
    fontWeight: "bold",
    fontSize: 16,
  },
  headLight: {
    backgroundColor: "#eeeeee",
    fontWeight: "bold",
    fontSize: 14,
  },
};

class ImportTFFData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      years: [],
      year: "",
      error: "",
      open: false,
      response: {},
    };
  }

  async componentDidMount() {
    try {
      this.getYears();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getYears = async () => {
    const years = await premiumApi.getYearsTFF();
    if (years) {
      this.setState({ years });
    }
  };

  handleChange = (e) => {
    this.setState({
      error: "",
      year: e.target.value,
    });
  };

  handleChangefile = (files) => {
    this.setState({ files });
  };

  handleupload = async () => {
    const { files, year } = this.state;
    if (files.length) {
      const response = await premiumApi.TFFDataImport(files, year);
      if (response) {
        if (response.status === "Success") {
          swal({
            title: "Opplastingen er vellykket!",
            icon: "success",
          });
        } else if (response.status === "Fail") {
          this.setState({
            open: true,
            response,
          });
        }
      } else {
        swal({
          title: "Opplastingen er mislykket!",
          text: "Teknisk feil. Kontakt administrator.",
          icon: "error",
          dangerMode: true,
        });
      }
    } else {
      toast.error("Velg en fil..");
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const DropzoneComponent = ({ onFilesSelected }) => {
      const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
        accept: ".xls,.xlsx,.txt,.csv",
        multiple: false,
        onDrop: (acceptedFiles) => onFilesSelected(acceptedFiles),
      });

      return (
        <div {...getRootProps()} style={{ border: "2px dashed #ccc", padding: "20px", textAlign: "center", cursor: "pointer" }}>
          <input {...getInputProps()} />
          <p>Dra og slipp en fil her eller klikk</p>
          {acceptedFiles.length > 0 && <p>Valgt fil: {acceptedFiles[0].name}</p>}
        </div>
      );
    };

    return (
      <Container maxWidth="lg">
        <main style={styles.layout}>
          <Paper style={styles.root}>
            <Grid container style={{ maxWidth: 600, margin: "10px auto", padding: "16px" }}>
              <Grid item lg={12}>
                <Tooltip
                  title={
                    <span style={{ fontSize: 15 }}>
                      .xlsx fil, kun to kolonner, Kolonnetittel på rad 1,
                      kolonne 1: TFF Auto kode (heltall) kolonne 2: markedsandel
                      (% med desimaler)
                    </span>
                  }
                  placement="bottom-start"
                >
                  <h2>Data import av TFF Auto Markedsandeler:</h2>
                </Tooltip>
              </Grid>

              <h3 style={{ paddingTop: 5 }}>Velg år:</h3>
              <Grid item lg={6} style={styles.marginLeft}>
                <FormControl fullWidth>
                  <InputLabel>År</InputLabel>
                  <Select
                    name="year"
                    value={this.state.year || ""}
                    onChange={this.handleChange}
                    error={this.state.error}
                  >
                    {this.state.years.map((year, index) => (
                      <MenuItem key={index} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* New Dropzone Component */}
              <Grid item lg={12} style={styles.gridPaddingTop}>
                <DropzoneComponent onFilesSelected={this.handleChangefile} />
              </Grid>

              <Grid item lg={12} style={styles.button}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<CloudDownloadIcon />}
                  onClick={this.handleupload}
                >
                  Last opp
                </Button>
              </Grid>

              {/* Dialog for Import Results */}
              <Grid item lg={12}>
                <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth>
                  <DialogTitle>{`Totalt ${this.state.response.totalRowsOfData} rader, ${this.state.response.successfulRows} rader er importert`}</DialogTitle>
                  <DialogContent>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={styles.headDark}>Rad</TableCell>
                            <TableCell style={styles.headDark}>Sak nr.</TableCell>
                            <TableCell style={styles.headDark} align="center">
                              Detaljer
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.keys(this.state.response).length !== 0 &&
                            this.state.response.failedRows.map((row) => (
                              <Fragment key={row.rowNr}>
                                <TableRow>
                                  <TableCell>{row.rowNr}</TableCell>
                                  <TableCell>{row.comment}</TableCell>
                                </TableRow>
                                {Object.keys(row.fieldErrors).length !== 0 &&
                                  row.fieldErrors.map((error, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{error.fieldNr}</TableCell>
                                      <TableCell>{error.fieldName}</TableCell>
                                      <TableCell>{error.errorMessage}</TableCell>
                                    </TableRow>
                                  ))}
                              </Fragment>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                      Avbryt
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </Container>
    );
  }
}


export default ImportTFFData;
